/**
 * Display-only currency converter (no page reload / no checkout redirect).
 * Auto-detects visitor country on first visit; respects manual selection after.
 */
(function () {
  var COUNTRY_CURRENCY = {
    BH: 'BHD',
    SA: 'SAR',
    AE: 'AED',
    KW: 'KWD',
    OM: 'OMR',
    QA: 'QAR',
    JO: 'JOD',
    US: 'USD',
    GB: 'GBP'
  };

  var RATES = {
    USD: 1,
    BHD: 0.38,
    OMR: 0.38,
    QAR: 3.64,
    AED: 3.67,
    JOD: 0.71,
    SAR: 3.75,
    KWD: 0.31,
    GBP: 0.79
  };

  var PRICE_SELECTORS =
    '.product-card__price, .product-single__price, .product-card__regular-price, .product-single__price--compare';

  function parseAmount(text) {
    var num = parseFloat(String(text).replace(/[^\d.]/g, ''));
    return isNaN(num) ? null : num;
  }

  function captureBasePrices(root) {
    (root || document).querySelectorAll(PRICE_SELECTORS).forEach(function (el) {
      if (el.dataset.basePrice) return;

      var fromContent = el.getAttribute('content');
      var amount = fromContent ? parseFloat(fromContent) : parseAmount(el.textContent);

      if (amount !== null) {
        el.dataset.basePrice = String(amount);
      }
    });
  }

  function formatPrice(amount, currency) {
    return Math.floor(amount) + ' ' + currency;
  }

  function convertPrices(currency, root) {
    if (!RATES[currency]) return;

    (root || document).querySelectorAll(PRICE_SELECTORS).forEach(function (el) {
      var base = parseFloat(el.dataset.basePrice);
      if (isNaN(base)) return;
      el.textContent = formatPrice(base * RATES[currency], currency);
    });
  }

  function updateCountryButtons(countryIso, currency) {
    document.querySelectorAll('input[name="country_code"]').forEach(function (input) {
      input.value = countryIso;
    });

    document.querySelectorAll('[data-currency-button]').forEach(function (btn) {
      var scope = btn.closest('.disclosure, .footer-country-fallback, localization-form, form') || btn.parentElement;
      var match = scope
        ? scope.querySelector('[data-country="' + countryIso + '"], [data-value="' + countryIso + '"]')
        : null;

      if (match) {
        btn.innerHTML = match.innerHTML;
        var caret = btn.querySelector('.icon-caret');
        if (!caret) {
          btn.insertAdjacentHTML(
            'beforeend',
            '<svg class="icon icon-caret" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>'
          );
        }
      } else if (currency) {
        var flag = btn.querySelector('.country-flag, .footer-country-fallback__flag');
        var flagHtml = flag ? flag.outerHTML : '';
        btn.innerHTML = flagHtml + currency;
      }
    });

    document.querySelectorAll('[data-country], [data-value]').forEach(function (link) {
      var code = link.dataset.country || link.dataset.value;
      var isActive = code === countryIso;
      link.classList.toggle('disclosure__link--active', isActive);
      link.classList.toggle('link', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function selectCurrency(currency, countryIso) {
    if (!RATES[currency]) currency = 'USD';

    localStorage.setItem('selectedCurrency', currency);
    if (countryIso) localStorage.setItem('selectedCountry', countryIso);

    captureBasePrices();
    convertPrices(currency);
    if (countryIso) updateCountryButtons(countryIso, currency);

    document.dispatchEvent(
      new CustomEvent('spotit:currency-changed', {
        detail: { currency: currency, country: countryIso }
      })
    );
  }

  function selectCountry(countryIso) {
    var currency = COUNTRY_CURRENCY[countryIso] || 'USD';
    selectCurrency(currency, countryIso);
    return true;
  }

  function getShopifyGeoCountry() {
    if (window.SpotItShopGeo && window.SpotItShopGeo.countryCode) {
      return String(window.SpotItShopGeo.countryCode).toUpperCase();
    }
    return null;
  }

  function fetchShopifyGeoCountry() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (!data || !data.detected_values || !data.detected_values.country) return null;
        return String(data.detected_values.country.handle || '').toUpperCase();
      })
      .catch(function () {
        return null;
      });
  }

  function applyGeoCurrency(countryIso) {
    if (!countryIso || !COUNTRY_CURRENCY[countryIso]) return false;
    return selectCountry(countryIso);
  }

  function initGeoCurrency() {
    if (localStorage.getItem('selectedCurrency')) return;

    if (applyGeoCurrency(getShopifyGeoCountry())) return;

    fetchShopifyGeoCountry().then(function (country) {
      if (localStorage.getItem('selectedCurrency')) return;
      applyGeoCurrency(country);
    });
  }

  function init() {
    captureBasePrices();

    var savedCurrency = localStorage.getItem('selectedCurrency');
    var savedCountry = localStorage.getItem('selectedCountry');

    if (savedCurrency && RATES[savedCurrency]) {
      convertPrices(savedCurrency);
      if (savedCountry) updateCountryButtons(savedCountry, savedCurrency);
      return;
    }

    initGeoCurrency();
  }

  window.SpotItCurrency = {
    selectCountry: selectCountry,
    selectCurrency: selectCurrency,
    captureBasePrices: captureBasePrices,
    convertPrices: convertPrices,
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    captureBasePrices(event.target);
    var savedCurrency = localStorage.getItem('selectedCurrency');
    if (savedCurrency) {
      convertPrices(savedCurrency, event.target);
    } else {
      initGeoCurrency();
    }
  });
})();
